// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__22srC","textanimation":"Hero_textanimation__3PlPc","name":"Hero_name__2tPY3","caption":"Hero_caption__nT65r"};